<template>
  <div class="inputgroupfare">
    <BaseSelect
      labelText="*補助方式"
      :value="subsidyMethod"
      :text="subsidyMethodFormMap(subsidyMethod)"
      :options="subsidyMethodOptions"
      :disabled="disabled"
      :required="true"
      @select="$emit('selectSubsidyMethod', $event)"
      class="inputgroupfare-field"
    />

    <BaseInput
      :value="milage"
      labelText="里程數"
      type="number"
      :disabled="disabled"
      @input="$emit('inputMilage', Number($event))"
      class="inputgroupfare-field"
    />

    <BaseInput
      :value="metreFare"
      labelText="跳表金額"
      type="number"
      :disabled="disabled"
      @input="$emit('inputMetreFare', Number($event))"
      class="inputgroupfare-field"
    >
      <b-button
        v-if="!disabled"
        slot="baseinput-addition"
        class="inputgroupfare-button"
        variant="outline-secondary"
        @click.prevent="$emit('autoCountMetreFare')"
        :disabled="autoCountButtonShow"
        >自動計算</b-button
      >
    </BaseInput>

    <BaseInput
      :value="subsidyFare"
      labelText="補助金額"
      type="number"
      :disabled="true"
      @input="$emit('inputSubsidyFare', Number($event))"
      class="inputgroupfare-field"
    />

    <BaseInput
      :value="actualFare"
      labelText="實收金額"
      type="number"
      :disabled="true"
      @input="$emit('inputActualFare', Number($event))"
      class="inputgroupfare-field"
    />
  </div>
</template>

<script>
import BaseInput from '@/components/base/BaseInput';
import BaseSelect from '@/components/base/BaseSelect';

import { subsidyMethodFormMap } from '@/utils/optionMaps';

export default {
  name: 'InputGroupFare',
  components: {
    BaseInput,
    BaseSelect
  },
  props: {
    subsidyMethodOptions: {
      type: Array,
      required: true
    },
    subsidyMethod: {
      type: Number,
      default: null
    },
    milage: {
      type: Number,
      default: 0
    },
    metreFare: {
      type: Number,
      default: 0
    },
    subsidyFare: {
      type: Number,
      default: 0
    },
    actualFare: {
      type: Number,
      default: 0
    },
    autoCountButtonShow: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    subsidyMethodFormMap(value) {
      return subsidyMethodFormMap(value);
    }
  }
};
</script>

<style lang="scss" scoped>
.inputgroupfare {
  &-field {
    padding: 20px 80px;
    border-bottom: 1px solid $border-light;
    &:hover {
      background-color: #fafafa;
    }
  }
  &-button {
    flex: 0 0 100px;
    margin-left: 10px;
    border-color: #ced4da;
  }
}

.small-padding {
  .inputgroupfare-field {
    padding: 10px 80px;
  }
}
</style>
